module.exports = __webpack_public_path__ + "static/9-5beb037c1cb2a2808732b90265a558e5.jpg";